import { useTranslation } from 'react-i18next'

import brain from '../../assets/images/brain.png'

import styles from './not-found.module.scss'

interface INotFoundProps {
    title?: string
}

function NotFound(props: INotFoundProps) {
    const { title } = props

    const { t } = useTranslation()

    return (
        <div className={styles.notFound}>
            <img className={styles.notFound__image} src={brain} alt=""></img>
            <h1 className={styles.notFound__title}>
                {title || t('not_found').toUpperCase()}
            </h1>
        </div>
    )
}

export default NotFound
